import firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyDFQhjTIhq2R8N_VEwTiiE9E43VEQ8nY0E",
  authDomain: "anxiety-7a76b.firebaseapp.com",
  projectId: "anxiety-7a76b",
  storageBucket: "anxiety-7a76b.appspot.com",
  messagingSenderId: "87332382677",
  appId: "1:87332382677:web:54f31ef4fcce21be243f5c"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

const auth = firebaseApp.auth();

export { db, auth };